// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x5gD","right":"styles_right__2ZoPi"};